/*
 * Copyright (c) Nexign, JSC, 2022.
 */
/**
 *
 * @author Evgeniy Naumov
 * @version 1.22.0
 * @since 1.22.0
 */

 import styled from 'styled-components';

 export const WizardReportConstructorStepStyled = styled.div`
    position: relative;
 `;



export const WizardReportConstructorStepTitleStyled = styled.h4`
    margin-bottom: 24px;
`
